import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { responsiveStateReducer as browser } from 'redux-responsive'
import { routerReducer as router } from 'react-router-redux'

// Our reducers
import address from './reducers/addressReducer'
import appConfig from './reducers/appConfigReducer'
import busy from './reducers/busyReducer'
import futureFormSubmitted from './reducers/futureFormSubmitted'
import latLng from './reducers/latLngReducer'
import lead from './reducers/leadReducer'
import leadError from './reducers/leadErrorReducer'
import positions from './reducers/positionsReducer'
import selectedPosition from './reducers/selectedPositionReducer'
import stateInfo from './reducers/stateInfoReducer'
import utm from './reducers/utmReducer'

const appReducer = combineReducers({
  address,
  appConfig,
  browser,
  busy,
  form,
  futureFormSubmitted,
  latLng,
  lead,
  leadError,
  positions,
  router,
  selectedPosition,
  stateInfo,
  utm,
})

export default appReducer



// WEBPACK FOOTER //
// ./src/reducer.js